export default {
  namespaced: true,
  hanwha_camera: {
    title: "Cámara Hanwha | Cámaras Hanwha",
    hanwha: "hanwha",
    name: "nombre",
    channel: "canal",
    type: "tipo",
    ip: "IP",
    class: "clase",
    encryption: "encriptación",
    poe: "¿Tiene POE?",
    poe_port: "puerto POE",
    http_port: "puerto http",
    https_port: "puerto https",
    port: "puerto",
    port_type: "tipo de puerto",
    rtsp_port: "puerto RTSP",
    serial_number: "número de serie",
    user: "usuario",
    dvr_validation: "tienes que seleccionar un DVR",
    device_information: "Información del dispositivo",
    confirm_delete: "¿Estás seguro de eliminar la cámara '%camera%'?",
    state: "Estado",
    fisheye: "Fisheye",
    send_to_seproban: "Enviar a SEPROBAN",
    group: "Grupo",
    user_id: "Id de Usuario",
    username: "Nombre de usuario",
    user_level: "Nivel de usuario",
    password: "Contraseña",
    viewer_access: "Acceso del espectador",
    password_confirm: "Confirmar contraseña para guardar cambios",
    change_password: "Cambiar contraseña",
    current_password: "Contraseña actual",
    new_password: "Nueva contraseña",
    confirm_new_password: "Confirmar nueva cotraseña",
    protocol: "Protocolo",
    local_ip: "IP local",
    model: "Modelo",
    group_id: "Id de Grupo",
  },
};
